import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import {fuseAnimations} from '../../../../core/animations';
import { fromEvent as observableFromEvent, Subscription } from 'rxjs';
import {NgxSpinnerService} from 'ngx-spinner';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { EditRecommendationComponent } from '../edit-recommendation/edit-recommendation.component';
import { FuseConfigService } from '../../../../core/services/config.service';
import { ELearningService } from '../../../../core/services/e-learning.service';
@Component({
  selector: 'recommend-elearnings',
  templateUrl: './recommend-elearnings.component.html',
  styleUrls: ['./recommend-elearnings.component.scss'],
  animations: fuseAnimations,
  standalone: false
})
export class RecommendElearnings implements OnInit , OnDestroy {
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  _search = '';
  eLearnings = [];
  _pageIndex = 0;
  _perPage = 50;
  eLearningsLength ;
  displayedColumns = [ 'title' , 'organization', 'recommended', 'recommendedBy', 'recommendationText' ];
  userId;

  private subscriptions =  new Subscription();

  constructor (private eLearningService: ELearningService , private spinner: NgxSpinnerService,
               public dialog: MatDialog, private translate: TranslateService,
               public toastr: ToastrService, private fuseConfig: FuseConfigService) {
    this.fuseConfig.userId.subscribe((res: any) => {
      if (res) {
        this.userId = res;
      }
    });
  }

  ngOnInit () {
    this.getElearnings();
    this.subscriptions.add(observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(1500) ,
      distinctUntilChanged())
      .subscribe(() => {
        if (this.filter.nativeElement.value && this.filter.nativeElement.value.replace(/ /g, '')
          && this.filter.nativeElement.value !== null && this.filter.nativeElement.value !== 'null') {
          this._search = this.filter.nativeElement.value;
          this.paginator.firstPage();
          this.cleanScrollEvent();
          this.getElearnings();
        } else if ((!this.filter.nativeElement.value || this.filter.nativeElement.value === '') && this._search){
          this._search = '';
          this.paginator.firstPage();
          this.cleanScrollEvent();
          this.getElearnings();
        }
      }));
  }

  getElearnings() {
    this.spinner.show();
    this.eLearningService.getElearningForRecommendation(this._pageIndex + 1, this._perPage, this._search).subscribe((response: any) => {
      this.eLearningsLength = response.length;
      let eLearnings = response.eLearnings;
      if (eLearnings.length) {
        this.eLearnings = eLearnings;
      } else {
        this.eLearnings = [];
      }
      this.spinner.hide();
    })
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  cleanScrollEvent() {
    let table = document.getElementById('recommendElearning');
    if (table) {
      table.scrollTop = 0;
    }
  }

  changePageEmitter(e) {
    this._pageIndex = e.pageIndex;
    this._perPage = e.pageSize;
    this.cleanScrollEvent();
    this.getElearnings();
  }

  editRecommendation(e, eLearning, readonly = false) {
    e.preventDefault();
    const dialogRef = this.dialog.open(EditRecommendationComponent , {
      width: '500px', data:{ text: eLearning.recommendation[0].recommendation_text, readonly}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          eLearningId: eLearning.id,
          recommendation_text: result,
          id: eLearning.recommendation[0].id,
        };
        this.eLearningService.addRecommendation(data).subscribe((res: any) => {
          if (res) {
            let index = this.eLearnings.findIndex(el => +el.id === +eLearning.id);
            if (index !== -1) {
              this.eLearnings[index].recommendation[0].recommendation_text = res.recommendation_text;
            }
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('event.recommendation_text_edited');
            this.toastr.success(msg, title);
          }
        });
      }
    });
  }
}
